const addAssetPanelActionsTypes = {
    SHOW_ADD_ASSET_PANEL: "SHOW_ADD_ASSET_PANEL",
    HIDE_ADD_ASSET_PANEL: "HIDE_ADD_ASSET_PANEL",
    UPDATE_PROGRESS: "UPDATE_PROGRESS",
    RESET_PANEL: "RESET_PANEL",
    ASSET_ADDED: "ASSET_ADDED",
    ASSET_ADDED_ERROR: "ASSET_ADDED_ERROR",
    FILE_ALREADY_EXIST: "FILE_ALREADY_EXIST",
    STOP_UPLOAD: "STOP_UPLOAD"
};

export default addAssetPanelActionsTypes;